export default function TermServices() {
    return (
        <section className="term-service">
            <div className="term-and-service-h1">
                <h1>Terms of Service</h1>
            </div>
            <div className="container-wrap">
                <div className="term-service-wrpp">
                    <div className="term-and-service-p">
                        <p>Welcome to HubSyntax. By using our website and services, you agree to these terms. Please read them carefully before contacting us. These terms govern how you use our services and form a legal agreement between you and HubSyntax. If you don’t agree to all the terms and conditions in this agreement, you are not permitted to use any of our services.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Services</p>
                    </div>
                    <div className="term-and-service-p" style={{ marginBottom: '13px' }}>
                        <p>HubSyntax provides a range of services related to Shopify, including </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>1. Shopify Store Development. </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>2. Shopify Store Design. </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>3. Shopify Store Customization.  </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>4.  Shopify Theme Customization.</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>5. Shopify Custom App Development. </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>6. Shopify Search Engine Optimization. </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>7. Shopify Click Rate Optimization. </p>
                    </div>
                    <div className="term-and-service-p" style={{ marginTop: '13px' }}>
                        <p> The specific services we provide to you will be detailed in the agreement or contract between you and HubSyntax. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Client Responsibilities </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>You are responsible for providing accurate information, timely feedback, and necessary access to your Shopify store while using our services to complete the project. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Payment Terms</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>The contract will detailed outline of the payment terms, including pricing, payment methods, and scheduling. If you delay payments, we may charge additional fees or suspend our services. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Intellectual Property</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We hold ownership of all work until full payment is received. After payment, ownership transfers to you.  </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Confidentiality</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>HubSyntax is committed to protecting your confidential information and expects you to do the same for ours. We will not share your personal information with third parties without your consent, except as required by law. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Termination</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>HubSyntax reserves the right to terminate or suspend your access to our services without any notice for violating any of these terms or for being harmful to other users, us, or third parties, or for any other reason.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Limitation of Liability</p>
                    </div>
                    <div className="term-and-service-p" style={{ marginBottom: '13px' }}>
                        <p>To the maximum extent permitted by law, HubSyntax will not be liable for:</p>
                    </div>
                    <div class="term-and-service-li"><ul>
                        <li >Indirect, incidental, or consequential damages.</li>
                        <li>Loss of revenue, data, or business opportunities.</li>
                        <li>Errors or delays caused by third-party platforms.</li>
                    </ul>
                    </div>
                    <div className="term-and-service-p">
                        <p>Our total liability for any claim related to our services is limited to the amount paid by the client for those services.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Third-Party Services</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Our site may include links to third-party websites or services not owned by HubSyntax. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Changes to Terms</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We may update these Terms of Service. Any material changes will be posted on this page with a revised date.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Contact</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>For questions, contact us at:</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>info@hubsyntax.com</p>
                    </div>
                </div>
            </div>
        </section>
    )
}
